import React, { Fragment } from 'react'

import Box from 'components/_new/layout/Box/Box'
import Text from 'components/_new/typography/Text/Text'
import HrLine from 'components/_new/layout/HrLine/HrLine'

import ArrivalDate from '../ArrivalDate/ArrivalDate'

import s from './MonthInfo.scss'
import messages from './messages'


const MonthInfo = ({ month, price, discountPrice }) => (
  <Fragment>
    <div className={s.monthInfo}>
      <ArrivalDate month={month} />
      <Box alignRight>
        {
          Boolean(discountPrice) ? (
            <Text
              message={messages.firstMonth}
              values={{ price, discountPrice }}
              size="16-24"
              html
            />
          ) : (
            <Text size="16-24" bold>{price}</Text>
          )
        }
      </Box>
    </div>
    <HrLine mt="8" mb="8" />
  </Fragment>
)


export default MonthInfo
